import React, {
	FunctionComponent,
	useCallback,
	useEffect,
	useState,
} from 'react'
import styled from 'styled-components'

interface LoggerProps {
	logger: {
		setLogLevel: (level: any) => void
		setEnabled: (state: boolean) => void
		getLogLevel: () => string
		isEnabled: () => boolean
	}
	loggerName: string
}

const LoggerContainer = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
`

export const Loggers: FunctionComponent<{ children?: never }> = () => {
	const [loggers, setLoggers] = useState<JSX.Element[]>([])
	useEffect(() => {
		const loggerClients: JSX.Element[] = []
		window.MONTHIO_LOGGER_CLIENTS?.forEach((logger, loggerName) =>
			loggerClients.push(
				<Logger key={loggerName} logger={logger} loggerName={loggerName} />,
			),
		)
		setLoggers(loggerClients)
	}, [])
	return <div>{loggers}</div>
}

const Logger = ({ logger, loggerName }: LoggerProps) => {
	const [loggerEnabled, setLoggerEnabled] = useState(logger.isEnabled())
	const toggleLogger = useCallback(() => {
		setLoggerEnabled((prev) => {
			logger.setEnabled(!prev)
			return !prev
		})
	}, [logger])
	return (
		<LoggerContainer key={loggerName}>
			<button onClick={toggleLogger}>
				{loggerEnabled ? 'disable' : 'enable'}
			</button>

			<select
				onChange={(e) => logger.setLogLevel(e.target.value as any)}
				defaultValue={(logger as any).getLogLevel()}
			>
				<option value="debug">debug</option>
				<option value="info">info</option>
				<option value="log">log</option>
				<option value="waning">warning</option>
				<option value="error">error</option>
			</select>
			{loggerName}
		</LoggerContainer>
	)
}
